import { useEffect, useRef, useState } from "react";
import { useReducedMotion } from "framer-motion";

const CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZĄĆĘŁŃÓŚŻ0123456789#%@&";

// One-time "decode" reveal: characters cycle briefly before settling.
export const ScrambleText = ({ text, className, duration = 900, start = true }) => {
  const reduce = useReducedMotion();
  const [display, setDisplay] = useState(reduce ? text : text);
  const started = useRef(false);

  useEffect(() => {
    if (reduce || !start || started.current) return;
    started.current = true;
    const begin = performance.now();
    let raf;
    const tick = (now) => {
      const t = Math.min((now - begin) / duration, 1);
      const revealCount = Math.floor(t * text.length);
      let out = "";
      for (let i = 0; i < text.length; i++) {
        const ch = text[i];
        if (ch === " " || i < revealCount) out += ch;
        else out += CHARS[Math.floor(Math.random() * CHARS.length)];
      }
      setDisplay(out);
      if (t < 1) raf = requestAnimationFrame(tick);
      else setDisplay(text);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [reduce, start, text, duration]);

  return <span className={className}>{display}</span>;
};
